// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"171":"f58b4f87","944":"c28008de"}[chunkId] + ".chunk.css";
};